import Joi from 'joi';

export const UserSchema = Joi.object({
  userName: Joi.string().required(),
  password: Joi.string().required(),
  firstName: Joi.string().required(),
  lastName: Joi.string().required(),
  email: Joi.string()
    .pattern(new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
    .required(),
  roles: Joi.array().items(
    Joi.string().valid('ผู้ดูแลระบบ', 'เจ้าหน้าที่ ส.กกภ.', 'ผู้แทน ร.นรม./รมต.นร', 'ผู้ช่วยผู้ตรวจราชการ', 'เจ้าหน้าที่ประจำจังหวัด')
  ).min(1).required()
});

export const UserResetPasswordSchema = Joi.object({
  id: Joi.string().required(),
  password: Joi.string().required(),
  admin: Joi.string().required(),
  adminPassword: Joi.string().required()
});
